var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadyTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#06c80c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1878 2189 c-30 -11 -71 -68 -463 -646 -396 -582 -559 -824 -567 -836 -3 -6 -110 90 -247 224 -248 240 -275 260 -333 246 -30 -8 -144 -111 -210 -190 -40 -48 -48 -65 -48 -98 0 -38 7 -49 91 -137 181 -192 674 -672 705 -687 43 -20 115 -19 160 2 41 20 42 21 601 843 706 1038 673 988 673 1038 0 55 -22 78 -167 176 -102 69 -146 84 -195 65z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyTick);
export default __webpack_public_path__ + "static/media/readyTick.d036e63718ab92be52bd935a3e452a8f.svg";
export { ForwardRef as ReactComponent };